import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import NavbarMex from '../components/navbarMex';
import BotonWhatsapp from '../botonWhatsapp/botonWhatsapp';
import { utils, writeFile } from 'xlsx';
import jsPDF from 'jspdf';
// Corregir la importación del plugin autotable
import 'jspdf-autotable';
import './cartera.css';
import BitacoraCartera from '../bitacoraCartera/bitacoraCartera';

const TableComponentC = () => {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [filterEntregado, setFilterEntregado] = useState('');
  const [filterPagado, setFilterPagado] = useState('');
  const [estadoEnvioOptions, setEstadoEnvioOptions] = useState([]);
  const [estadoPagoOptions, setEstadoPagoOptions] = useState([]);
  const [showManifestModal, setShowManifestModal] = useState(false);
  const [manifestForm, setManifestForm] = useState({
    id_transportadora: '',
    fecha: new Date().toISOString().split('T')[0]
  });
  const [manifestData, setManifestData] = useState(null);
  const [manifestLoading, setManifestLoading] = useState(false);

  const usuario_id = localStorage.getItem('usuario_id');
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`https://api.99envios.app/api/online/cartera_completa/${usuario_id}`)
      .then(response => {
        setData(response.data);

        // Extraer valores únicos de 'estado_del_envio'
        const uniqueEstadoEnvio = [...new Set(response.data.map(item => item.estado_del_envio).filter(Boolean))];
        setEstadoEnvioOptions(uniqueEstadoEnvio);

        // Extraer valores únicos de 'estado_del_pago'
        const uniqueEstadoPago = [...new Set(response.data.map(item => item.estado_pago).filter(Boolean))];
        setEstadoPagoOptions(uniqueEstadoPago);
      })
      .catch(error => console.error('Error fetching data: ', error));
  }, [usuario_id]);

  const handleSearch = (event) => {
    setSearch(event.target.value);
    setCurrentPage(1);
  };

  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const sortedData = React.useMemo(() => {
    let sortableData = [...data];
    if (sortConfig.key !== '') {
      sortableData.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableData;
  }, [data, sortConfig]);

  const filteredData = sortedData.filter(item => {
    const searchMatch = (
      (item.nombre_destinatario?.toLowerCase() || '').includes(search.toLowerCase()) ||
      (item.direccion_destinatario?.toLowerCase() || '').includes(search.toLowerCase()) ||
      (item.telefono_destinatario?.toLowerCase() || '').includes(search.toLowerCase()) ||
      (item.ciudad_destino?.toLowerCase() || '').includes(search.toLowerCase()) ||
      (item.estado_del_envio?.toLowerCase() || '').includes(search.toLowerCase()) ||
      (item.nombre_sucursal?.toLowerCase() || '').includes(search.toLowerCase()) ||
      (item.numero_de_guia?.toString().toLowerCase() || '').includes(search.toLowerCase()) ||
      item.valor_comercial?.toString().toLowerCase().includes(search.toLowerCase()) ||
      item.valor_flete?.toString().toLowerCase().includes(search.toLowerCase()) ||
      item.valor_consignado?.toString().toLowerCase().includes(search.toLowerCase()) ||
      (item.fecha_consignacion?.toLowerCase() || '').includes(search.toLowerCase())
    );

    const entregadoMatch = filterEntregado === '' || 
      item.estado_del_envio?.toLowerCase() === filterEntregado.toLowerCase();

    const pagadoMatch = filterPagado === '' || 
      item.estado_pago?.toLowerCase() === filterPagado.toLowerCase();

    return searchMatch && entregadoMatch && pagadoMatch;
  });

  const indexOfLastEntry = currentPage * entriesPerPage;
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
  const currentEntries = filteredData.slice(indexOfFirstEntry, indexOfLastEntry);
  const totalPages = Math.ceil(filteredData.length / entriesPerPage);

  const formatDateForDisplay = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString; // Return original if invalid
    return date.toISOString().split('T')[0];
  };

  const exportToExcel = () => {
    // Excluir valor_servicio del conjunto de datos a exportar
    const dataToExport = filteredData.map(({ valor_servicio, ...rest }) => rest);
    const worksheet = utils.json_to_sheet(dataToExport);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, "Data");
    writeFile(workbook, `Cartera_Completa_${formatDateForDisplay(new Date())}.xlsx`);
  };

  const getPaginationGroup = () => {
    let start = Math.max(currentPage - 2, 1);
    let end = Math.min(start + 5, totalPages);

    if (end === totalPages) {
      start = Math.max(end - 5, 1);
    }

    return Array.from({ length: end - start + 1 }, (_, idx) => start + idx);
  };

  const handleManifestSubmit = async (e) => {
    e.preventDefault();
    setManifestLoading(true);
    try {
      const codigo_sucursal = localStorage.getItem('codigoSucursal');
      const requestData = {
        ...manifestForm,
        codigo_sucursal
      };
      
      const response = await axios.post('https://99envios.app/api/online/generar-manifiesti/pdf', requestData);
      setManifestData(response.data);
      // We don't immediately close the modal now since we want to show the response data
      setManifestLoading(false);
    } catch (error) {
      console.error('Error generating manifest:', error);
      alert('Error al generar el manifiesto');
      setManifestLoading(false);
    }
  };

  const closeManifestModal = () => {
    setShowManifestModal(false);
    setManifestData(null);
  };

  const openPdfInNewTab = (url) => {
    if (url) {
      window.open(url, '_blank');
    }
  };

  const generatePDF = () => {
    if (!manifestData || !manifestData.datos_gias) return;
    
    try {
      // Create a new PDF document - explicitly add jsPDF options to avoid errors
      const doc = new jsPDF({
        orientation: 'landscape',
        unit: 'mm',
        format: 'a4'
      });
      
      // Add title
      doc.setFontSize(18);
      doc.setTextColor(76, 69, 177); // #4c45b1
      doc.text(`Manifiesto de ${manifestData.transportadora || 'Envíos'}`, 14, 15);
      
      // Add date
      doc.setFontSize(10);
      doc.setTextColor(100, 100, 100);
      const today = new Date().toLocaleDateString('es-CO', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
      doc.text(`Fecha: ${today}`, 14, 22);
      
      // Add transportadora info
      doc.setFontSize(12);
      doc.setTextColor(76, 69, 177);
      doc.text(`Transportadora: ${manifestData.transportadora || ''}`, 14, 29);
      
      // Enfoque más simplificado para dibujar la tabla
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const margin = 10;
      const startY = 40;
      let currentY = startY;
      const rowHeight = 10;
      
      // Definimos encabezados y anchos
      const columns = [
        { header: "Número", width: 25 },
        { header: "Fecha", width: 25 },
        { header: "Flete", width: 25 },
        { header: "Contrapago", width: 25 },
        { header: "Contenido", width: 50 },
        { header: "Destinatario", width: 40 },
        { header: "Teléfono", width: 30 },
        { header: "Peso", width: 20 }
      ];
      
      // Función para dibujar una fila
      const drawRow = (items, isHeader = false) => {
        let x = margin;
        
        // Configurar estilo según sea encabezado o fila de datos
        if (isHeader) {
          doc.setFillColor(76, 69, 177);
          doc.setTextColor(255, 255, 255);
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(8);
        } else {
          doc.setTextColor(0, 0, 0); // Asegurar que el texto sea negro
          doc.setFont('helvetica', 'normal');
          doc.setFontSize(7);
        }
        
        // Dibujar cada celda en la fila
        columns.forEach((column, i) => {
          // Dibujar el rectángulo de fondo
          doc.rect(x, currentY, column.width, rowHeight, isHeader ? 'F' : 'S');
          
          // Calcular posición de texto
          let textX = x + 2; // Margen interno
          const textY = currentY + 6; // Centrado vertical aproximado
          
          // Si es un valor monetario, alinear a la derecha
          if ((i === 2 || i === 3) && !isHeader) {
            // Para valores monetarios, alineamos a la derecha
            const text = items[i];
            const textWidth = doc.getStringUnitWidth(text) * doc.internal.getFontSize() / doc.internal.scaleFactor;
            textX = x + column.width - 2 - textWidth;
          }
          
          // Escribir texto
          doc.text(items[i], textX, textY);
          x += column.width;
        });
        
        currentY += rowHeight;
        
        // Añadir nueva página si es necesario
        if (currentY > pageHeight - margin * 2) {
          doc.addPage();
          currentY = margin;
          
          // Si estamos en una nueva página, dibujamos el encabezado nuevamente
          if (!isHeader) {
            const headers = columns.map(col => col.header);
            drawRow(headers, true);
          }
        }
      };
      
      // Dibujar encabezado
      const headers = columns.map(col => col.header);
      drawRow(headers, true);
      
      // Dibujar filas de datos
      manifestData.datos_gias.forEach(guia => {
        try {
          const destinatario = guia.destinatario 
            ? `${guia.destinatario.nombre || ''} ${guia.destinatario.primer_apellido || ''}`.trim()
            : 'N/A';
          
          const row = [
            guia.numero_preenvio || 'N/A',
            (guia.fecha_creacion || '').substr(0, 10) || 'N/A',
            `$${parseFloat(guia.valor_flete || 0).toLocaleString('es-CO')}`,
            `$${parseFloat(guia.valor_contrapago || 0).toLocaleString('es-CO')}`,
            (guia.dice_contener || '').substr(0, 25) || 'N/A', // Limitamos longitud
            destinatario.substr(0, 20) || 'N/A', // Limitamos longitud
            (guia.destinatario?.telefono || 'N/A').substr(0, 12),
            `${guia.peso || 0} kg`
          ];
          
          drawRow(row, false);
        } catch (error) {
          console.error('Error al procesar fila:', error);
        }
      });
      
      // Añadir resumen al final
      currentY += 5; // Espacio después de la tabla
      
      doc.setFontSize(10);
      doc.setTextColor(50, 50, 50);
      doc.text(`Total Guías: ${manifestData.datos_gias.length}`, margin, currentY + 5);
      
      // Calculate totals safely with error handling
      let totalFlete = 0;
      let totalContrapago = 0;
      
      manifestData.datos_gias.forEach(guia => {
        try {
          totalFlete += parseFloat(guia.valor_flete || 0);
          totalContrapago += parseFloat(guia.valor_contrapago || 0);
        } catch (error) {
          // Skip problematic values
        }
      });
      
      doc.text(`Total Valor Flete: $${totalFlete.toLocaleString('es-CO')}`, margin, currentY + 12);
      doc.text(`Total Valor Contrapago: $${totalContrapago.toLocaleString('es-CO')}`, margin, currentY + 19);
      
      // Add footer
      doc.setFontSize(8);
      doc.setTextColor(150, 150, 150);
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.text(
          `Página ${i} de ${pageCount} - Generado por 99envios - ${today}`,
          doc.internal.pageSize.width / 2,
          doc.internal.pageSize.height - 10,
          { align: "center" }
        );
      }
      
      // Save the PDF with safer filename
      const safeName = manifestData.transportadora ? 
                        manifestData.transportadora.replace(/[^a-zA-Z0-9]/g, '_') : 
                        'Envios';
      doc.save(`Manifiesto_${safeName}_${new Date().toISOString().split('T')[0]}.pdf`);
      
    } catch (error) {
      console.error('Error detallado al generar el PDF:', error);
      alert('Error al generar el PDF: ' + (error.message || 'Error desconocido'));
    }
  };

  return (
    <>
      <NavbarMex title="Cartera Completa" />
      <BitacoraCartera />
      <div className="table-containerCA">
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
          <button onClick={() => navigate('/dashboard99/historico-cartera')} className="historicos-button">
            Históricos Cartera
          </button>
          <button onClick={() => setShowManifestModal(true)} className="manifest-button">
            Generar Manifiesto
          </button>
        </div>

        {/* Manifest Modal */}
        {showManifestModal && (
          <div className="modal-overlay">
            <div className="modal-content" style={{ 
              width: manifestData ? '85%' : '450px', 
              maxWidth: '1200px', 
              maxHeight: '90vh',
              overflow: 'auto',
              padding: '25px',
              borderRadius: '12px',
              boxShadow: '0 5px 15px rgba(0, 0, 0, 0.2)'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h2 style={{ margin: 0, color: '#4c45b1' }}>
                  {manifestData ? 'Manifiesto Generado' : 'Generar Manifiesto'}
                </h2>
                <button 
                  onClick={closeManifestModal} 
                  style={{ 
                    background: 'none', 
                    border: 'none', 
                    fontSize: '24px',
                    cursor: 'pointer',
                    color: '#666'
                  }}
                >
                  &times;
                </button>
              </div>

              {!manifestData ? (
                <form onSubmit={handleManifestSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                    <label htmlFor="transportadora" style={{ fontWeight: 'bold' }}>Seleccionar Transportadora:</label>
                    <select
                      id="transportadora"
                      value={manifestForm.id_transportadora}
                      onChange={(e) => setManifestForm({...manifestForm, id_transportadora: e.target.value})}
                      required
                      style={{ 
                        padding: '10px', 
                        borderRadius: '5px',
                        border: '1px solid #ddd'
                      }}
                    >
                      <option value="">Seleccionar Transportadora</option>
                      <option value="1">Interrapidisimo</option>
                      {/* <option value="2">Servientrega</option>
                      <option value="3">TCC</option>
                      <option value="4">Coordinadora</option> */}
                    </select>
                  </div>
                  
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                    <label htmlFor="fecha" style={{ fontWeight: 'bold' }}>Fecha:</label>
                    <input
                      id="fecha"
                      type="date"
                      value={manifestForm.fecha}
                      onChange={(e) => setManifestForm({...manifestForm, fecha: e.target.value})}
                      required
                      style={{ 
                        padding: '10px', 
                        borderRadius: '5px',
                        border: '1px solid #ddd'
                      }}
                    />
                  </div>
                  
                  <div className="modal-buttons" style={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    gap: '10px',
                    marginTop: '15px' 
                  }}>
                    <button 
                      type="submit" 
                      disabled={manifestLoading}
                      style={{ 
                        padding: '10px 20px',
                        backgroundColor: manifestLoading ? '#cccccc' : '#4c45b1',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: manifestLoading ? 'default' : 'pointer',
                        fontWeight: 'bold'
                      }}
                    >
                      {manifestLoading ? 'Generando...' : 'Generar'}
                    </button>
                    <button 
                      type="button" 
                      onClick={closeManifestModal}
                      style={{ 
                        padding: '10px 20px',
                        backgroundColor: '#f5f5f5',
                        color: '#333',
                        border: '1px solid #ddd',
                        borderRadius: '5px',
                        cursor: 'pointer'
                      }}
                    >
                      Cancelar
                    </button>
                  </div>
                </form>
              ) : (
                <div className="manifest-results">
                  <div className="manifest-header" style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center',
                    marginBottom: '20px',
                    padding: '15px',
                    borderRadius: '8px',
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #e9ecef'
                  }}>
                    <div className="manifest-logos" style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                      {manifestData.logo_transportadora && (
                        <img 
                          src={manifestData.logo_transportadora} 
                          alt="Logo Transportadora" 
                          height="60" 
                          style={{ objectFit: 'contain' }}
                        />
                      )}
                      {manifestData.logo_99envios && (
                        <img 
                          src={manifestData.logo_99envios} 
                          alt="Logo 99envios" 
                          height="45" 
                          style={{ objectFit: 'contain' }}
                        />
                      )}
                    </div>
                    <h3 style={{ 
                      color: '#4c45b1', 
                      fontSize: '22px',
                      margin: '0'
                    }}>
                      Manifiesto {manifestData.transportadora || 'de Envíos'}
                    </h3>
                    <div style={{ minWidth: '80px' }}></div> {/* Spacer for balance */}
                  </div>
                  
                  {manifestData.datos_gias && manifestData.datos_gias.length > 0 ? (
                    <div className="manifest-guias">
                      <h4 style={{ 
                        marginBottom: '15px',
                        color: '#333',
                        fontSize: '18px',
                        borderBottom: '2px solid #4c45b1',
                        paddingBottom: '10px'
                      }}>
                        Guías incluidas en el manifiesto
                      </h4>
                      <div className="table-wrapper" style={{ 
                        maxHeight: '50vh', 
                        overflowY: 'auto',
                        borderRadius: '8px',
                        border: '1px solid #e9ecef'
                      }}>
                        <table className="custom-table" style={{ 
                          width: '100%',
                          borderCollapse: 'collapse',
                          fontSize: '14px'
                        }}>
                          <thead style={{ position: 'sticky', top: 0, backgroundColor: '#4c45b1', color: 'white' }}>
                            <tr>
                              <th style={{ padding: '12px 15px', textAlign: 'left' }}>Número Preenvío</th>
                              <th style={{ padding: '12px 15px', textAlign: 'left' }}>Fecha Creación</th>
                              <th style={{ padding: '12px 15px', textAlign: 'right' }}>Valor Flete</th>
                              <th style={{ padding: '12px 15px', textAlign: 'right' }}>Valor Contrapago</th>
                              <th style={{ padding: '12px 15px', textAlign: 'left' }}>Dice Contener</th>
                              <th style={{ padding: '12px 15px', textAlign: 'right' }}>Valor Declarado</th>
                              <th style={{ padding: '12px 15px', textAlign: 'left' }}>Destinatario</th>
                              <th style={{ padding: '12px 15px', textAlign: 'left' }}>Teléfono</th>
                              <th style={{ padding: '12px 15px', textAlign: 'left' }}>Dirección</th>
                              <th style={{ padding: '12px 15px', textAlign: 'center' }}>Peso</th>
                            </tr>
                          </thead>
                          <tbody>
                            {manifestData.datos_gias.map((guia, index) => (
                              <tr key={index} style={{ 
                                backgroundColor: index % 2 === 0 ? '#f8f9fa' : 'white',
                                borderBottom: '1px solid #e9ecef'
                              }}>
                                <td style={{ padding: '10px 15px', textAlign: 'left' }}>{guia.numero_preenvio}</td>
                                <td style={{ padding: '10px 15px', textAlign: 'left' }}>{guia.fecha_creacion}</td>
                                <td style={{ padding: '10px 15px', textAlign: 'right' }}>${parseFloat(guia.valor_flete || 0).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                <td style={{ padding: '10px 15px', textAlign: 'right' }}>${parseFloat(guia.valor_contrapago || 0).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                <td style={{ padding: '10px 15px', textAlign: 'left' }}>{guia.dice_contener}</td>
                                <td style={{ padding: '10px 15px', textAlign: 'right' }}>${parseFloat(guia.valor_declarado || 0).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                <td style={{ padding: '10px 15px', textAlign: 'left' }}>{guia.destinatario ? `${guia.destinatario.nombre} ${guia.destinatario.primer_apellido || ''}` : 'N/A'}</td>
                                <td style={{ padding: '10px 15px', textAlign: 'left' }}>{guia.destinatario?.telefono || 'N/A'}</td>
                                <td style={{ padding: '10px 15px', textAlign: 'left' }}>{guia.destinatario?.direccion || 'N/A'}</td>
                                <td style={{ padding: '10px 15px', textAlign: 'center' }}>{guia.peso} kg</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      
                      <div className="manifest-summary" style={{ 
                        marginTop: '20px',
                        padding: '15px',
                        backgroundColor: '#f8f9fa',
                        border: '1px solid #e9ecef',
                        borderRadius: '8px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap'
                      }}>
                        <div style={{ 
                          display: 'flex',
                          alignItems: 'center',
                          padding: '10px 15px',
                          borderRadius: '5px',
                          backgroundColor: '#e9ecef'
                        }}>
                          <strong style={{ marginRight: '10px' }}>Total Guías:</strong> 
                          <span style={{ fontSize: '18px', color: '#4c45b1' }}>{manifestData.datos_gias.length}</span>
                        </div>
                        
                        <div style={{ 
                          display: 'flex',
                          alignItems: 'center',
                          padding: '10px 15px',
                          borderRadius: '5px',
                          backgroundColor: '#e9ecef'
                        }}>
                          <strong style={{ marginRight: '10px' }}>Total Valor Flete:</strong> 
                          <span style={{ fontSize: '18px', color: '#4c45b1' }}>
                            ${manifestData.datos_gias.reduce((sum, guia) => sum + parseFloat(guia.valor_flete || 0), 0).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </span>
                        </div>
                        
                        <div style={{ 
                          display: 'flex',
                          alignItems: 'center',
                          padding: '10px 15px',
                          borderRadius: '5px',
                          backgroundColor: '#e9ecef'
                        }}>
                          <strong style={{ marginRight: '10px' }}>Total Valor Contrapago:</strong> 
                          <span style={{ fontSize: '18px', color: '#4c45b1' }}>
                            ${manifestData.datos_gias.reduce((sum, guia) => sum + parseFloat(guia.valor_contrapago || 0), 0).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </span>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div style={{ 
                      padding: '40px', 
                      textAlign: 'center',
                      backgroundColor: '#f8f9fa',
                      borderRadius: '8px',
                      border: '1px solid #e9ecef'
                    }}>
                      <p style={{ fontSize: '18px', color: '#6c757d' }}>No hay guías disponibles para este manifiesto.</p>
                    </div>
                  )}
                  
                  <div className="modal-buttons" style={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    gap: '15px',
                    marginTop: '25px' 
                  }}>
                   
                    <button 
                      type="button" 
                      onClick={generatePDF}
                      style={{ 
                        padding: '12px 24px',
                        backgroundColor: '#217346', // Color verde de Excel
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                      }}
                    >
                      <span style={{ fontSize: '18px' }}>⬇️</span> Descargar PDF
                    </button>
                    <button 
                      type="button" 
                      onClick={closeManifestModal}
                      style={{ 
                        padding: '12px 24px',
                        backgroundColor: '#f5f5f5',
                        color: '#333',
                        border: '1px solid #ddd',
                        borderRadius: '5px',
                        cursor: 'pointer'
                      }}
                    >
                      Cerrar
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        <div className="table-controls">
          <div className="controls-group">
            <label htmlFor="entries">Mostrar</label>
            <select
              id="entries"
              name="entries"
              value={entriesPerPage}
              onChange={(e) => {
                setEntriesPerPage(parseInt(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
            <input
              type="text"
              placeholder="Buscar"
              value={search}
              onChange={handleSearch}
              className="search-input"
            />
          </div>
          <div className="filters-group">
            <select
              value={filterEntregado}
              onChange={(e) => {
                setFilterEntregado(e.target.value);
                setCurrentPage(1);
              }}
              className="filter-select"
            >
              <option value="">Estado Envío</option>
              {estadoEnvioOptions.map((estado, index) => (
                <option key={index} value={estado.toLowerCase()}>
                  {estado}
                </option>
              ))}
            </select>
            <select
              value={filterPagado}
              onChange={(e) => {
                setFilterPagado(e.target.value);
                setCurrentPage(1);
              }}
              className="filter-select"
            >
              <option value="">Estado Pago</option>
              {estadoPagoOptions.map((estado, index) => (
                <option key={index} value={estado.toLowerCase()}>
                  {estado}
                </option>
              ))}
            </select>
          </div>
          <div className="export-group">
            <button onClick={exportToExcel} className="export-button">Exportar a Excel</button>
          </div>
        </div>
        <div className="table-wrapper">
          <table className="custom-table">
            <thead>
              <tr>
                <th onClick={() => handleSort('codigo_sucursal')}>Código Sucursal</th>
                <th onClick={() => handleSort('numero_de_guia')}>Número de Guía</th>
                <th onClick={() => handleSort('valor_comercial')}>Valor Comercial</th>
                <th onClick={() => handleSort('valor_flete')}>Valor Flete</th>
                <th onClick={() => handleSort('valor_consignado')}>Valor Consignado</th>
                <th onClick={() => handleSort('fecha_consignacion')}>Fecha de Consignación</th>
                <th onClick={() => handleSort('estado_del_envio')}>Estado de Envío</th>
                <th onClick={() => handleSort('estado_del_pago')}>Estado de Pago</th>
                <th onClick={() => handleSort('nombre_destinatario')}>Destinatario</th>
                <th onClick={() => handleSort('direccion_destinatario')}>Dirección</th>
                <th onClick={() => handleSort('telefono_destinatario')}>Teléfono</th>
                <th onClick={() => handleSort('ciudad_destino')}>Ciudad</th>
              </tr>
            </thead>
            <tbody>
              {currentEntries.map((item, index) => (
                <tr key={index}>
                  <td>{item.codigo_sucursal}</td>
                  <td>{item.numero_de_guia}</td>
                  <td>{item.valor_comercial}</td>
                  <td>{item.valor_flete}</td>
                  <td>{item.valor_consignado}</td>
                  <td>{item.fecha_consignacion}</td>
                  <td>{item.estado_del_envio}</td>
                  <td>{item.estado_pago}</td>
                  <td>{item.nombre_destinatario}</td>
                  <td>{item.direccion_destinatario}</td>
                  <td>{item.telefono_destinatario}</td>
                  <td>{item.ciudad_destino}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="pagination">
          <button
            className="page-button"
            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            &lt;
          </button>
          {getPaginationGroup().map(number => (
            <button
              key={number}
              className={`page-button ${currentPage === number ? 'active' : ''}`}
              onClick={() => setCurrentPage(number)}
            >
              {number}
            </button>
          ))}
          <button
            className="page-button"
            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
            disabled={currentPage === totalPages}
          >
            &gt;
          </button>
        </div>
      </div>
      <BotonWhatsapp />
    </>
  );
};

export default TableComponentC;
